import Button from 'components/Button';
import renderField from '../../../../../components/Field/reduxForm';
import DateTimeFieldValidate from '../../../../../components/DateTimeField';
import { NumberField } from 'components/Field/NumberField';
import renderSelect from 'components/Select/reduxForm';
import Loading from 'components/Loading/index';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import {
  getRequiredFn,
  validateNumberSimpleLength,
} from '../../../../../utils/reduxForm/validations';
import * as inputFilters from '../../../../../utils/reduxForm/inputFilters';
import checkExample from './check-example.jpg';
import './style.scss';
import { numberFieldRestrict15_2Fn } from 'modules/Taps/components/NDFL3/services/CommonValidations';

const requiredFn = getRequiredFn();
const validateLength16 = validateNumberSimpleLength(16);
const operationTypeOptions = [
  { label: 'Приход', value: 'INCOME' },
  {
    label: 'Возврат прихода',
    value: 'RETURN_INCOME',
  },
];

class FillingForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    autofill: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <div>
        <form onSubmit={this.props.handleSubmit}>
          <div className="cRow cRow__mobile">
            <div className="cCol cCol__50">
              <Field
                name={'operationType'}
                label="Вид кассового чека"
                isRequired={true}
                validate={requiredFn}
                component={renderSelect}
                options={operationTypeOptions}
                parse={(params) => params.value}
              />

              <DateTimeFieldValidate
                name={'originDate'}
                isRequired={true}
                label={'Дата и время'}
                validate={requiredFn}
                tooltipContent={'Дата и время чека в формате ДД.ММ.ГГ ЧЧ.ММ'}
              />

              <Field
                component={NumberField}
                name={'originSum'}
                isRequired={true}
                isAllowed={numberFieldRestrict15_2Fn}
                label={'Сумма'}
                validate={requiredFn}
                tooltipContent={'Сумма чека с копейками (включая НДС)'}
                decimalScale={2}
              />

              <Field
                component={renderField}
                name={'fnNumber'}
                label={'ФН №'}
                isRequired={true}
                maxLength={16}
                normalize={inputFilters.numberOnly}
                validate={[requiredFn, validateLength16]}
                tooltipContent={
                  'Номер фискального накопителя. Так же ФН, ФН ККТ. Значение из 16 цифр'
                }
              />

              <Field
                name={'fiscalDocument'}
                component={renderField}
                label={'ФД №'}
                isRequired={true}
                maxLength={10}
                validate={requiredFn}
                normalize={inputFilters.numberOnly}
                tooltipContent={'Номер фискального документа. Так же ФД. Не более 10 цифр'}
              />

              <Field
                name={'fiscalSignature'}
                component={renderField}
                isRequired={true}
                maxLength={10}
                label={'ФП'}
                validate={requiredFn}
                normalize={inputFilters.numberOnly}
                tooltipContent={'Фискальный признак документа. Так же ФПД. Не более 10 цифр'}
              />
            </div>
            <div className="cCol cCol__50">
              <figure className="check-example">
                <figcaption className="grey justify">
                  <span className="bold">Пример чека.</span> Обратите внимание, расположение
                  реквизитов и их наименование может отличаться от примера
                </figcaption>
                <img src={checkExample} alt={''} />
              </figure>
            </div>
          </div>
          <div className="footer">
            <Button type="button" onClick={this.props.goBack}>
              Назад
            </Button>
            <Button
              onClick={noop}
              isDisabled={this.props.loading}
              type="submit"
              buttonStyle={{ position: 'relative', minWidth: '140px' }}
            >
              {this.props.loading ? <Loading isLight={true} /> : 'Найти чек'}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'addCashierForm',
})(FillingForm);
